// Helper to format file size in a human-readable way
export function humanFileSize(size: number): string {
  if (size < 1024) return size + ' B';
  const units = ['KB', 'MB', 'GB', 'TB'];
  let i = -1;
  do {
    size = size / 1024;
    i++;
  } while (size >= 1024 && i < units.length - 1);
  return size.toFixed(1) + ' ' + units[i];
}

// Helper to build preview/download API URLs. When running the CRA dev server on port 3000
// some proxy setups may not forward Range headers correctly; in that case use the backend
// origin (assumed to be :5001) so media streaming works during local development.
export function getApiUrl(endpoint: string, params: Record<string, string>): string {
  const relative = `${endpoint}?${new URLSearchParams(params).toString()}`;
  const loc = window.location;
  if (loc.hostname === 'localhost' && loc.port === '3000') {
    return `${loc.protocol}//${loc.hostname}:5001${relative}`;
  }
  return relative;
}

// Encode each segment of a relative path for use in a /table/... URL.
export function encodePath(p: string): string {
  return p.split('/').filter(Boolean).map(encodeURIComponent).join('/');
}
